import React, { useEffect } from 'react';
//import keycloakConfig from './keycloak';
//import Keycloak from 'keycloak-js';
import { useUserContext } from './context/user.context';
import { environment } from './environment';
import AdminPanelApp from "./router/Admin/AdminPanelApp";
import DashboardApp from "./router/Dashboard/DashboardApp";
import { keycloak } from "./Authentication/keycloak";
import { useUserValidationContext } from './context/user-validating.context';
import Loader from './layouts/Loader/Loader';

/*const keycloakConfig = {
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};*/

const App = ({ children }) => {
    //const [keycloak, setKeycloak] = useState(null);

    const { isGlobalUserAdmin, isUserAdmin } = useUserContext();

    const { isValidating } = useUserValidationContext()

    useEffect(() => {
        //const keycloakInstance = new Keycloak(keycloakConfig);
        //setKeycloak(keycloakInstance);

        /*keycloakInstance.init({ onLoad: 'login-required' }).then((authenticated) => {
            if (authenticated) {
                console.log('User is authenticated');
            }
        });*/

        // Initialize an inactivity timer (e.g., 15 minutes)
        let inactivityTimer;
        const resetTimer = () => {
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(() => {
                keycloak.logout(); // Log out after inactivity
                console.log("AUTOLOGOUT EXECUTED!!!")
            }, process.env.REACT_APP_KEYCLOAK_AUTO_LOGOUT_TIMER || environment.KEYCLOAK_AUTO_LOGOUT_TIMER); // 
            //console.log("AUTOLOGOUT STARTED FOR 15MINS")
        };

        // Reset the timer on user interaction (e.g., mousemove or keydown)
        document.addEventListener('mousemove', resetTimer);
        //document.addEventListener('mousedown', resetTimer);
        document.addEventListener('keydown', resetTimer);

        return () => {
            clearTimeout(inactivityTimer); // Clear the timer when the component unmounts
            document.removeEventListener('mousemove', resetTimer);
            //  document.removeEventListener('mousedown', resetTimer);
            document.removeEventListener('keydown', resetTimer);
        };
    }, []);

    /* useEffect(() => {
        console.log("IS GLOBAL USER ADMIN => ", isGlobalUserAdmin)
    }, [isGlobalUserAdmin]) */


    if (isValidating) return <Loader />

    return (
        <>
            {
                (isGlobalUserAdmin || isUserAdmin)
                    ? <AdminPanelApp>{children}</AdminPanelApp>
                    : <DashboardApp>{children}</DashboardApp>
            }
        </>

    );
};

export default App;
